import { ReactElement, useEffect } from "react";
import { Accordion } from "./accordion";
import { useAccordionStore } from "src/storage";

export const AccordionWrapperForm = ({
  children,
  title,
  sectionKey,
  defaultExpanded = true,
}: {
  children: ReactElement;
  title: string;
  sectionKey: string;
  defaultExpanded?: boolean;
}) => {
  const expanded = useAccordionStore((state) => state.sectionsMap[sectionKey]);
  const registerSection = useAccordionStore((state) => state.registerSection);
  const setExpanded = useAccordionStore((state) => state.setExpanded);
  const unregisterSection = useAccordionStore(
    (state) => state.unregisterSection
  );

  // Auto-registrazione all'mount
  useEffect(() => {
    registerSection(sectionKey, defaultExpanded);

    // Cleanup: rimuovi la sezione quando il componente si smonta
    return () => {
      unregisterSection(sectionKey);
    };
  }, [sectionKey, defaultExpanded, registerSection, unregisterSection]);

  const handleChange = (isExpanded: boolean) => {
    setExpanded(sectionKey, isExpanded);
  };

  return (
    <Accordion
      arrowVersus="left"
      classes="d-block"
      title={title}
      classesTitle="title-xs"
      classesHead="data-entry-accordion"
      defaultExpanded={defaultExpanded}
      expanded={expanded} // controlla dallo store
      onChange={handleChange} // aggiorna lo store
      classesIconNotExpanded="filter-primary"
      classesTitleNotExpanded="c-primary"
    >
      {children}
    </Accordion>
  );
};
